import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatMessageSentPayload = z.object({
    messageId: schemaId,
    metaMessageId: z.string().min(1),
});

export type Schema_ChatMessageSentPayload = z.infer<typeof schemaChatMessageSentPayload>;
